import { render, staticRenderFns } from "./TrainDetail.vue?vue&type=template&id=304a2362&"
import script from "./TrainDetail.vue?vue&type=script&lang=js&"
export * from "./TrainDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports